import shortUUID from 'short-uuid';
import slugGen from 'slug';
import * as validatorModule from 'validator';

const { isUUID } = validatorModule.default || validatorModule;

// Update the slug mode to use lowercase by default
slugGen.defaults.mode = 'rfc3986';

// Used to convert b/w UUID and flickerBase58 format
const shortUUIDTranslator = shortUUID();

/**
 * Generates a slug from a title and ID.
 *
 * @param {String} title The title of the item to slugify
 * @param {String} id    The id of the item to slugify
 * @returns {String}     Slug starting with title and ending with UUID, separated by a hyphen
 */
const toSlug = (title, id) => `${slugGen(title)}-${shortUUIDTranslator.fromUUID(id)}`;

/**
 * Generates a slug from a title.
 *
 * @param {String} title The title of the item to slugify
 * @returns {String}     Slug based on the title
 */
const toSlugTitle = (title) => slugGen(title);

/**
 * Parses a slug to a UUID.
 *
 * @param {String} slug  The slug to parse
 * @returns {String} The parsed slug.
 */
const fromSlug = (slug) => shortUUIDTranslator.toUUID(slug.split('-').pop());

/**
 * Determines if a slug contains a valid short UUID that also
 * translates to a valid UUID.
 *
 * @param {String} slug  The slug to parse
 * @returns {Boolean}  True if the slug is valid, false otherwise.
 */
const validateSlug = (slug) => {

	const translator = shortUUID(shortUUID.constants.flickrBase58, {
		// Allows us to still validate older slugs generated with v3
		// of the short-uuid library
		consistentLength: false,
	});

	const shortUUIDToTest = slug.split('-').pop();


	if (shortUUIDToTest.length <= 1) {
		return false;
	}

	return translator.validate(shortUUIDToTest, true);

};

/**
 * Parses a slug or a UUID.
 *
 * @param {String} slugOrUUID  The slug or UUID to parse
 * @returns {String} The parsed slug.
 */
const fromSlugOrUUID = (slugOrUUID) => {

	if (!slugOrUUID || slugOrUUID === '') {
		return slugOrUUID;
	}

	// Check if we need to parse the UUID
	if (isUUID(slugOrUUID)) {

		return slugOrUUID;

	}

	// Otherwise, we need to parse the slug
	return fromSlug(slugOrUUID);

};

export {
	toSlug,
	toSlugTitle,
	fromSlug,
	fromSlugOrUUID,
	validateSlug,
};
